export const categoriesList = [
	{ id: 1, name: "All", icon: "fa-border-all" },
	{ id: 2, name: "Fashion", icon: "fa-shirt" },
	{ id: 3, name: "Food", icon: "fa-utensils" },
	{ id: 4, name: "Electronics", icon: "fa-tv" },
	{ id: 5, name: "Salon", icon: "fa-spa" },
	{ id: 6, name: "Beauty Product", icon: "fa-wand-magic-sparkles" },
	{ id: 7, name: "Jewelry", icon: "fa-gem" },
];
